module.exports = __webpack_public_path__ + "static/media/dududu.bd21a4b.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/voice/dududu.mp3
// module id = PlNr
// module chunks = 1